export const saveBlobDownload = (body: Blob, contentDisposition: string | null): void => {
  const href = window.URL.createObjectURL(body);
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', /filename="(.*)"/.exec(contentDisposition ?? '')?.[1] ?? 'report');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
